export function base_url(path = ""){
    return `${window.location.origin}/${path}`;
}